export const messageByJob = {
  threadClosed: 'This message thread is closed.',
};

